export default __webpack_public_path__ + "static/media/poster.eca61735.png";